/**
 * Перечисление ролей пользователей в системе Мой Арендатор.
 * Синхронизировано с бэкенд Enum App\Enums\UserRole.
 */
export const UserRole = Object.freeze({
  LANDLORD: 1,    // Арендодатель / Собственник
  TENANT: 2,      // Арендатор / Съемщик
  ALL_IN_ONE: 3,  // Всё в одном (и сдает, и снимает)
  EMPLOYEE: 4,    // Сотрудник арендатора
  ADMIN: 99       // Администратор платформы
})

/**
 * Названия ролей на русском языке.
 */
export const UserRoleLabels = Object.freeze({
  [UserRole.LANDLORD]: 'Арендодатель',
  [UserRole.TENANT]: 'Арендатор',
  [UserRole.ALL_IN_ONE]: 'Всё в одном',
  [UserRole.EMPLOYEE]: 'Сотрудник',
  [UserRole.ADMIN]: 'Администратор'
})

/**
 * Проверка: имеет ли пользователь права арендодателя (собственника).
 * @param {number|string|null} roleId
 * @returns {boolean}
 */
export function isLandlordRole(roleId) {
  const num = Number(roleId)
  return num === UserRole.LANDLORD || num === UserRole.ALL_IN_ONE
}

/**
 * Проверка: имеет ли пользователь права арендатора (съемщика).
 * @param {number|string|null} roleId
 * @returns {boolean}
 */
export function isTenantRole(roleId) {
  const num = Number(roleId)
  return num === UserRole.TENANT || num === UserRole.ALL_IN_ONE
}

/**
 * Проверка: является ли пользователь сотрудником арендатора.
 * @param {number|string|null} roleId
 * @returns {boolean}
 */
export function isEmployeeRole(roleId) {
  return Number(roleId) === UserRole.EMPLOYEE
}

/**
 * Проверка: является ли пользователь администратором платформы.
 * @param {number|string|null} roleId
 * @returns {boolean}
 */
export function isAdminRole(roleId) {
  return Number(roleId) === UserRole.ADMIN
}

/**
 * Получить имя маршрута главного дашборда для указанной роли.
 * @param {number|string|null} roleId
 * @returns {object} { name: string }
 */
export function getUserDashboardRoute(roleId) {
  if (roleId === null || roleId === undefined || roleId === '') {
    return { name: 'auth.welcome' }
  }
  const num = Number(roleId)
  if (isAdminRole(num)) {
    return { name: 'admin.dashboard' }
  }
  if (isEmployeeRole(num)) {
    return { name: 'employer.dashboard' }
  }
  if (num === UserRole.TENANT) {
    return { name: 'tenant.dashboard' }
  }
  return { name: 'landlord.dashboard' }
}

export default UserRole

